function getTimeRow(time) {
    // If it's already in "HH:mm:ss" format
    if (typeof time === 'string' && time.includes(':') && time.length <= 8) {
        const [hours, minutes] = time.split(':');
        return `time-${hours}${minutes}`;
    }

    // Else fallback to full datetime parsing
    const date = new Date(time);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `time-${hours}${minutes}`;
}

function convertDateTimeToTime(dateTimeString) {
    // Skapa ett Date-objekt från den givna strängen
    const date = new Date(dateTimeString);

    // Formatera timmar och minuter
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    // Returnera formaterad sträng
    return `${hours}:${minutes}`;
}

function formatTimeToLabel(time) {
    let date;

    const today = new Date();

    if (/^\d{2}:\d{2}$/.test(time)) {
        // "HH:mm" format
        const [hours, minutes] = time.split(':');
        date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), hours, minutes);
    } else if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
        // "HH:mm:ss" format
        const [hours, minutes, seconds] = time.split(':');
        date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), hours, minutes, seconds);
    } else {
        // Fallback to full datetime
        date = new Date(time);
    }

    return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    }).toLowerCase();
}

function calculateDurationInMinutes(startsAt, endsAt) {
    const startDate = new Date(startsAt);
    const endDate = new Date(endsAt);
    const duration = endDate - startDate; // Difference in milliseconds
    return duration / 60000; // Convert to minutes
}

function fixTag(tagObj) {
    if (!tagObj) {
        return
    }
    let tag = "";
    if (tagObj.org) {
        tag = tagObj.org;
    } else {
        tag = tagObj;
    }
    tag = tag.replace(/\./g, "");
    tag = tag.replace(/ & /g, "-");
    tag = tag.replace(/ /g, "-");
    tag = tag.replace(/#/g, " ");
    return tag;
}

function toSafeTrackName(name) {
    return name.replace(/\s+/g, '_'); // "ZOOM OUT" -> "ZOOM_OUT"
}

export const SET_SESSIONS = (state, sessions) => {
    state.sessions = sessions.map(session => {
        const speakerName = session.speakers.map(speaker => speaker.name).join(", ")
        return {
            _id: session.id,
            start: convertDateTimeToTime(session.startsAt),
            end: convertDateTimeToTime(session.endsAt),
            duration: calculateDurationInMinutes(session.startsAt, session.endsAt),
            description: session.description,
            speakerName: speakerName,
            title: session.title,
            tag: fixTag(session.categories[1].categoryItems[0].name),
            weekDay: new Date(session.startsAt).getDay(),
            roomName: session.room,
        }
    });
}
export const SET_SPEAKERS = (state, speakers) => {
    state.speakers = speakers.map((speaker) => {
        let sessionTags = [];
        const updatedSessions = speaker.sessions.map((session) => {
            const matchedSession = state.sessions.find(
                (s) => s._id === String(session.id)
            );
            if (matchedSession) {
                if (matchedSession.tag) {
                    sessionTags.push(fixTag(matchedSession.tag));
                }
                return {
                    _id: matchedSession._id,
                    title: matchedSession.title,
                    roomName: matchedSession.roomName,
                    description: matchedSession.description,
                    tag: matchedSession.tag,
                    weekDay: matchedSession.weekDay,
                    start: formatTimeToLabel(matchedSession.start),
                    end: formatTimeToLabel(matchedSession.end),
                    duration: matchedSession.duration,
                };
            }
            // fallback: minimal session info
            return {
                _id: String(session.id),
                title: session.name,
            };
        });

        return {
            _id: speaker.id,
            firstName: speaker.firstName,
            lastName: speaker.lastName,
            profilePicture: speaker.profilePicture,
            bio: speaker.bio,
            sessionTags: sessionTags,
            sessions: updatedSessions,
        };
    });
}

export const SET_SCHEDULE_GRID = (state, scheduleGrid) => {
    // Filter away rooms arrays which have duplicate sessions (both in timeSlots and rooms)
    scheduleGrid = scheduleGrid.map((day) => ({
        date: day.date,
        timeSlots: day.timeSlots, // only keep this
    }));

    // Flatten array (all sessions in timeslot instead of nested rooms arrays)
    // Add CSS column and row grid for Program page
    const firstTrack = 'track-DNA-start';
    const lastTrack = 'track-ZOOM_OUT-end';

    state.scheduleGrid = scheduleGrid.map((day) => ({
        date: day.date,
        timeSlots: day.timeSlots.map((slot) => {
            const sessions = slot.rooms.map((room) => {
                const session = room.session;
                const safeRoom = toSafeTrackName(room.name);
                const isPlenum = slot.rooms.length === 1;

                return {
                    _id: session.id,
                    title: session.title,
                    roomId: room.id,
                    roomName: room.name,
                    startsAt: session.startsAt,
                    endsAt: session.endsAt,
                    displayTime: formatTimeToLabel(session.startsAt),
                    duration: calculateDurationInMinutes(session.startsAt, session.endsAt),
                    isServiceSession: session.isServiceSession,
                    isPlenumSession: session.isPlenumSession,
                    tag: session.categories[1] ? fixTag(session.categories[1].categoryItems[0].name) : "",
                    speakerName: session.speakers[0] ? session.speakers[0].name : "",
                    speakerId: session.speakers[0] ? session.speakers[0].id : "",
                    timerow: getTimeRow(session.startsAt) + ' / ' + getTimeRow(session.endsAt),
                    gridColumn: isPlenum
                        ? `${firstTrack} / ${lastTrack}`
                        : `track-${safeRoom}`,
                };
            });
            return {
                slotStart: formatTimeToLabel(slot.slotStart),
                timeRowLabel: getTimeRow(slot.slotStart),
                sessions,
            };
        }),
    }));
}

export const setCount = (state, count) => {
    state.count = count;
}


// WEBPACK FOOTER //
// ./src/store/mutations.js